import { createSlice } from '@reduxjs/toolkit'

const initialState: any = {
    allLedger: [],
    loading: false,
    error: null,
    status: null,
    totalPages: 0,
    totalRecords: 0,
    offset: 0,
    pageSize: 0,
    pageNumber: 0,
    orderBy: "asc",
}

const sovereignEventLedgerSlice = createSlice({
    name: 'sovereignEventLedger',
    initialState,
    reducers: {
        setLedger(state, action: any) {
            // API response: { totalRecords: N, data: [ {...}, ... ] }
            const payload = action.payload?.data ?? action.payload;
            state.allLedger = Array.isArray(payload?.data) ? payload.data
                : Array.isArray(payload?.content) ? payload.content
                    : [];
            state.totalRecords = payload?.totalRecords ?? payload?.totalElements ?? 0;
            state.totalPages = payload?.totalPages ?? 0;
            state.offset = payload?.pageable?.offset ?? 0;
            state.pageSize = payload?.pageable?.pageSize ?? 0;
            state.pageNumber = payload?.pageable?.pageNumber ?? 0;
        },
        setAllLedger(state, action: any) {
            state.allLedger = action.payload.data || [];
        },
    },
})

export const { setLedger, setAllLedger } = sovereignEventLedgerSlice.actions

export const getAllLedgerDetails = (state: any) => state.sovereignEventLedger.allLedger;
export const getLedgerTotalRecords = (state: any) => state.sovereignEventLedger.totalRecords;
export const getLedgerTotalPages = (state: any) => state.sovereignEventLedger.totalPages;


export default sovereignEventLedgerSlice.reducer
